import React from 'react';
import { IconProps } from '../types/types';

const CVX: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="#F0F3FA" d="M0 0h18v18H0z"/><path d="M4 12.31V8.928l5 1.69-5 1.692z" fill="#92002B"/><path d="M4 8.31V4.928l5 1.69L4 8.31z" fill="#0066B1"/><path d="M14 8.928l-5 1.69L4 12.31l5 1.691 5-1.691v-3.38z" fill="#E81736"/><path d="M14 4.928l-5 1.69L4 8.31l5 1.691 5-1.691v-3.38z" fill="#00A3E9"/></svg>
);

export default CVX;